export default __webpack_public_path__ + "static/media/pause-white-light.a3603126.svg";